'use client';

import { ErrorPage } from '../../../_ui/utils/ErrorPage';

export default ErrorPage;
